/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The configuration of the animatic for an electric underfloor heater.
 */
export type AnimaticElectricUnderfloorHeaterConfig = {};

/** @internal */
export const AnimaticElectricUnderfloorHeaterConfig$inboundSchema: z.ZodType<
  AnimaticElectricUnderfloorHeaterConfig,
  z.ZodTypeDef,
  unknown
> = z.object({});
/** @internal */
export type AnimaticElectricUnderfloorHeaterConfig$Outbound = {};

/** @internal */
export const AnimaticElectricUnderfloorHeaterConfig$outboundSchema: z.ZodType<
  AnimaticElectricUnderfloorHeaterConfig$Outbound,
  z.ZodTypeDef,
  AnimaticElectricUnderfloorHeaterConfig
> = z.object({});

export function animaticElectricUnderfloorHeaterConfigToJSON(
  animaticElectricUnderfloorHeaterConfig:
    AnimaticElectricUnderfloorHeaterConfig,
): string {
  return JSON.stringify(
    AnimaticElectricUnderfloorHeaterConfig$outboundSchema.parse(
      animaticElectricUnderfloorHeaterConfig,
    ),
  );
}
export function animaticElectricUnderfloorHeaterConfigFromJSON(
  jsonString: string,
): SafeParseResult<AnimaticElectricUnderfloorHeaterConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      AnimaticElectricUnderfloorHeaterConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnimaticElectricUnderfloorHeaterConfig' from JSON`,
  );
}
